module.exports = __webpack_public_path__ + "static/WEDDING E&M-367-b8f55945f7eef99b9e49ace2a12fdceb.jpg";